// extracted by mini-css-extract-plugin
export default {"wrapper":"AllReviews_wrapper__vBZDG","filterWrapper":"AllReviews_filterWrapper__PY7HN","filter":"AllReviews_filter__dxPQE"};